import { FaPhoneAlt } from "react-icons/fa";

const PhoneButton = () => {
  return (
    <a
      href="tel:+919883218266" // 👈 apna number daalo
      className="fixed bottom-3 left-2 
                 bg-gradient-gold
                 text-black md:p-3 p-2 rounded-full 
                 shadow-lg transition-all duration-300 
                 hover:scale-110 z-50"
    >
      <FaPhoneAlt size={20} />
    </a>
  );
};

export default PhoneButton;
